import { ActionContext } from 'vuex';
import { get, post, ApiResult, checkToken, checkUserInfo } from '../helpers/api';
import { User } from '@/model';

type AuthenticationResult = ApiResult<{user: User, next?: string}>;

async function signIn(ctx: ActionContext<any,any>, data: any) {
    const endpoint = `/babel/_api/v1/auth/signin`;

    let result: AuthenticationResult = await post(endpoint, data).then(res => res.data);

    ctx.commit('updateAuthentication', { result: result.result, user: result.data && result.data.user });

    return result;
}

async function signOut(ctx: ActionContext<any,any>) {
    const endpoint = `/babel/_api/v1/auth/logout`;

    let result: AuthenticationResult = await post(endpoint).then(res => res.data);

    ctx.commit('updateAuthentication', { result: result.result, user: null });

    return result;
}

async function authenticationCheck(ctx: ActionContext<any,any>, data: any) {
    const endpoint = `/_api/v1/auth/check`;

    if (!ctx.state.isAuthenticated) {
        let result: AuthenticationResult = await get(endpoint)
            .then(res => res.data);

        ctx.commit('updateAuthentication', { result: result.result, user: result.data && result.data.user });

        return result;
    }
    else {
        return { result: "OK" };
    }
}

function passwordSendUpdateEmail(ctx: ActionContext<any,any>, data: any) {
    const endpoint = `/babel/_api/v1/auth/password/send-update-email`;

    return post(endpoint, data).then(res => res.data);
}

function passwordUpdate(ctx: ActionContext<any,any>, data: any) {
    const endpoint = `/babel/_api/v1/auth/password/update`;

    return post(endpoint, data).then(res => res.data);
}

export const actions = {
    signIn,
    signOut,
    authenticationCheck,
    passwordSendUpdateEmail,
    passwordUpdate
}